
const ETS_MM_BASE_URL = 'https://menu-app.ets-demos.com';
const ETS_MM_CDN_URL = '';

(function () {
	var etsMmLoadJs = function (url, callback) {
		var script = document.createElement("script");
		script.type = "text/javascript";

		if (script.readyState) {
			script.onreadystatechange = function () {
				if (script.readyState == "loaded" || script.readyState == "complete") {
					script.onreadystatechange = null;
					callback();
				}
			};
			// For any other browser.
		} else {
			script.onload = function () {
				callback();
			};
		}

		script.src = url;
		document.getElementsByTagName("head")[0].appendChild(script);
	};

	var etsMMJavascript = function ($) {

		var etsMM =  {
			isInitApp: false,
			isFetching: false,
			cdnUrl: '',
			ETS_MM_ENABLE: false,
			ETS_MM_MENUS: '',
			shop_domain: '',
			fetch: function () {
				console.log('begin fetch', this.isFetching)
				if (this.isFetching)
					return false;
				this.isFetching = true;
				var url = '';
				if (this.cdnUrl) {
					url = this.fetchDataUrl + '/' + this.shop_domain + '/form.js';
				} else {
					url = this.fetchDataUrl + '?shop=' + this.shop_domain;
				}
				var xhr = new XMLHttpRequest();
				xhr.onreadystatechange = function () {
					var DONE = 4;
					var OK = 200;
					console.log('xhr', xhr)
					if (xhr.readyState == DONE && xhr.status == OK) {
						//Success
						var responseText = xhr.responseText;
						var json = JSON.parse(responseText);
						console.log('json fetch menu1111111: ', json);
						if (json.success && json.data) {
							console.log('menu data', JSON.parse(json.data.menus))
							if (json.data.enable)
								etsMM.ETS_MM_ENABLE = json.data.enable;
							if (json.data.menus)
								etsMM.ETS_MM_MENUS = JSON.parse(json.data.menus);
							etsMM.run();
						}
					}
				}
				xhr.open('GET', url);
				xhr.send();
			},
			initMenu: function () {
				console.log('init app menu:', this.isInitApp)
				if (this.isInitApp) {
					return false;
				}
				if (typeof ETS_MM_BASE_URL !== 'undefined' && ETS_MM_BASE_URL) {
					etsMM.baseUrl = ETS_MM_BASE_URL;
				}
				if (typeof ETS_MM_CDN_URL !== 'undefined' && ETS_MM_CDN_URL) {
					etsMM.cdnUrl = ETS_MM_CDN_URL;
				}
				if (etsMM.cdnUrl) {
					etsMM.fetchDataUrl = etsMM.cdnUrl + '/cache';
				} else {
					etsMM.fetchDataUrl = etsMM.baseUrl + '/clients/fetch';
				}
				if (!this.shop_domain && typeof Shopify !== "undefined" && Shopify && typeof Shopify.shop !== "undefined" && Shopify.shop)
					this.shop_domain = Shopify.shop;

				if (this.ETS_MM_MENUS && this.ETS_MM_ENABLE) {
					console.log('mm 1');
					this.run();
				} else {
					console.log('mm 2');
					this.fetch();
				}

			},
			run: function () {
				this.isInitApp = true;
				if (typeof etsMM.ETS_MM_MENUS.settings == 'undefined') {
					return false;
				}
				const ETS_MM_SELECTED = etsMM.ETS_MM_MENUS.settings.menu_position.value;
				var ETS_MM_SELECTOR = "";
				if (etsMM.ETS_MM_MENUS.settings.menu_position.value == 'replace_menu_from_nav') {
					ETS_MM_SELECTOR = etsMM.ETS_MM_MENUS.settings.menu_position.select_menu;
				} else if (etsMM.ETS_MM_MENUS.settings.menu_position.value == 'replace_by_id_class') {
					ETS_MM_SELECTOR = etsMM.ETS_MM_MENUS.settings.menu_position.enter_id_class;
				} else if (etsMM.ETS_MM_MENUS.settings.menu_position.value == 'embeded_code') {
					ETS_MM_SELECTOR = etsMM.ETS_MM_MENUS.settings.menu_position.embeded_code;
				}
				var ETS_MM_SELECTOR_MOBILE = '';
				if (etsMM.ETS_MM_MENUS.settings.menu_position.value == 'replace_by_id_class') {
					ETS_MM_SELECTOR_MOBILE = etsMM.ETS_MM_MENUS.settings.menu_position.enter_id_class_mobile;
				}
				if (ETS_MM_SELECTED == 'auto' || ETS_MM_SELECTED == 'replace_by_id_class') {
					var isJqueryObject = false;
					var menuSelectorDesktop = '#AccessibleNav';
					var menuSelectorMobile = '#MobileNav';
					if (ETS_MM_SELECTED == 'auto') {
						if (!$(menuSelectorDesktop).length) {
							var navEts = etsMM.findMenuEtsTheme();
							if (navEts) {
								menuSelectorDesktop = navEts;
								menuSelectorMobile = null;
							}
						}
						if (!$(menuSelectorDesktop).length) {
							var navItem = etsMM.findRoleNavigation(false);
							if (navItem) {
								menuSelectorDesktop = navItem;
								isJqueryObject = true;
							}
						}

						if (!(menuSelectorMobile)) {
							var navItemMobile = etsMM.findRoleNavigation(true);
							if (navItemMobile) {
								menuSelectorDesktop = navItemMobile;
								isJqueryObject = true;
							}
						}
					}
					if (ETS_MM_SELECTED == 'replace_by_id_class') {
						menuSelectorDesktop = ETS_MM_SELECTOR;
						menuSelectorMobile = ETS_MM_SELECTOR_MOBILE;
					}
					if (!$(menuSelectorDesktop).is('ul')) {
						menuSelectorDesktop = menuSelectorDesktop + '>ul';
					}
					if (!$(menuSelectorMobile).is('ul')) {
						menuSelectorMobile = menuSelectorMobile + '>ul';
					}
					var sameMenu = false;
					if (menuSelectorDesktop == menuSelectorMobile) {
						sameMenu = true;
					}
					etsMM.createMegamenu($(menuSelectorDesktop));
					if ($(menuSelectorMobile).length && !sameMenu) {
						etsMM.createMegamenu($(menuSelectorMobile), true);
					} else if ($('#nt_menu_canvas').length) {
						setTimeout(function () {
							etsMM.createMegamenu($('#nt_menu_canvas ' + menuSelectorMobile), true);
						}, 1000);
					}
				} else if (ETS_MM_SELECTED == 'embeded_code') {
					if ($('.ets_mm_embeddedcode').length) {
						$('.ets_mm_embeddedcode').html('<ul class="mm-embedded"></ul>');
						etsMM.createMegamenu($('.ets_mm_embeddedcode>ul'));
					}
				} else {
					etsMM.findMenuSelector(ETS_MM_SELECTOR, ETS_MM_SELECTED);
				}
				etsMM.flipClock.init();
				etsMM.initEvent();
			},
			initEvent: function () {
				if (etsMM.ETS_MM_MENUS.settings.other_settings.menu_trigger == "click")
				{
					$(document).on('click', '.js-ets-mm-menu-item-hover-open.open-vertical-first-tab-menu .menu-item-header-title', function () {
						if ($(this).parent().hasClass('is_menu_tabs') && !$(this).parent().find('ul.list-tabs>li.open').length) {
							$(this).parent().find('ul.list-tabs>li:first-child').addClass('open');
						}
					});
					$(document).on('click', '.js-ets-mm-menu-item-hover-open', function () {
						openMenu($(this));
					});
					$(document).on('click', '.js-ets-mm-tab-item-hover-open', function (e) {
						e.stopPropagation();
						$('.js-ets-mm-tab-item-hover-open').removeClass('open');
						openMenu($(this));
					});
					$(document).click(function (event) {
						var $target = $(event.target);
						if (!$target.closest('.js-ets-mm-menu-item-hover-open').length) {
							$('.js-ets-mm-menu-item-hover-open').removeClass('open');
							$('.list-menus').find('.static-open-vertical-first-menu').addClass('open-vertical-first-tab-menu');
						}
					});

				}
				else
				{
					$(document).on('mouseenter', '.js-ets-mm-menu-item-hover-open.open-vertical-first-tab-menu .menu-item-header-title', function () {
						if ($(this).parent().hasClass('is_menu_tabs') && !$(this).parent().find('ul.list-tabs>li.open').length) {
							$(this).parent().find('ul.list-tabs>li:first-child').addClass('open');
						}
					});
					$(document).on('mouseenter touchend', '.js-ets-mm-menu-item-hover-open,.js-ets-mm-tab-item-hover-open', function () {
						console.log('aaaaa')
						openMenu($(this));

					});
					$(document).on('mouseleave', '.js-ets-mm-menu-item-hover-open,.js-ets-mm-tab-item-hover-open', function () {
						console.log('bbbb')
						closeMenu($(this))
					});

				}
			},
			findRoleNavigation: function (onMobile) {
				onMobile = onMobile || false;
				var navItem = null;
				var navEl = $('[role="navigation"]');
				if (navEl.length) {
					navEl.each(function () {
						var attrClass = $(this).attr('class');
						if (typeof attrClass === 'string' && ((!onMobile && !attrClass.match(/mobile/)) || (onMobile && attrClass.match(/mobile/)))) {
							if ($(this).is('ul'))
								navItem = $(this);
							else if ($(this).find('ul').length) {
								navItem = $(this).find('ul');
							}
							return true;
						}
					});
				}
				return navItem;
			},
			findMenuEtsTheme: function () {
				if ($('.ets-mega_menu ul.mm_menus_ul').length) {
					return '.ets-mega_menu ul.mm_menus_ul';
				}
				return null;
			},
			findMenuSelector: function (selector, selected) {

				if (selected == 'replace_menu_from_nav') {
					var shopifyLinks = [];
					if (typeof ETS_MM_LINK_LIST !== "undefined" && ETS_MM_LINK_LIST) {
						for (var i = 0; i < ETS_MM_LINK_LIST.length; i++) {
							if (ETS_MM_LINK_LIST[i].id == selector) {
								shopifyLinks = ETS_MM_LINK_LIST[i].items;
								break;
							}
						}
					}

					if (shopifyLinks.length) {
						var firstLink = shopifyLinks[0];
						if ($('a[href="' + firstLink + '"]').length) {
							$('[href="' + firstLink + '"]').each(function () {
								if ($(this).closest('li').length && $(this).closest('li').parent('ul').length) {
									var countLink = 0;
									for (var si = 0; si < shopifyLinks.length; si++) {
										if ($(this).closest('li').parent('ul').find('a[href="' + shopifyLinks[si] + '"]').length) {
											countLink++;
										}
									}
									if (countLink == shopifyLinks.length) {
										//Check menu for mobile or desktop
										etsMM.createMegamenu($(this).closest('li').parent('ul'));
									}
								}
							});
						}
					}
				}
			},
			showMenuFromSelector: function (selector, isMenuMobile) {
				isMenuMobile = isMenuMobile || false;
				selector.addClass('list-menus').find('li').addClass('ets_mm_item_disabled');
				selector.parent().addClass('ets_megamenu ' + (isMenuMobile ? 'mm-mobile ' : '') + $('#ets-megamenu-wireframe .ets_megamenu').attr('class'));
				selector.append($('#ets-megamenu-wireframe .list-menus>li').addClass('ets_mm_menu_item_li').parent().html());
			},
			isMobile: function () {
				var width = $(window).width();
				if (width < 992) {
					return true;
				}
				return false;
			},
			escapeRegExp: function (text) {
				return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&').toLowerCase();
			},
			coundownClock: function () {
				if ($('.ets-mm-countdown').length) {
					$('.ets-mm-countdown').each(function () {
						var endDate = $(this).attr('data-datetime');
						if (endDate) {
							var clock = '<div class="ets-mm-countdown-clock">' +
								'<span class="ets-mm-countdown-number ets-mm-countdown-days"></span>' +
								'<span class="ets-mm-countdown-number ets-mm-countdown-hours"></span>' +
								'<span class="ets-mm-countdown-number ets-mm-countdown-minutes"></span>' +
								'<span class="ets-mm-countdown-number ets-mm-countdown-seconds"></span>' +
								'</div>';
							$(this).html(clock);
							$(this).removeClass('hide');
							etsMM.setCountdown(this, endDate);
						}
					});
				}
			},
			setCountdown: function (element, endDate) {
				var countDownDate = new Date(endDate).getTime();
				var clockInterval = setInterval(function () {

					// Get today's date and time
					var now = new Date().getTime();

					// Find the distance between now and the count down date
					var distance = countDownDate - now;

					// Time calculations for days, hours, minutes and seconds
					var days = Math.floor(distance / (1000 * 60 * 60 * 24));
					var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					var seconds = Math.floor((distance % (1000 * 60)) / 1000);

					// Display the result in the element with id="demo"
					$(element).find('.ets-mm-countdown-days').html(days);
					$(element).find('.ets-mm-countdown-hours').html(hours);
					$(element).find('.ets-mm-countdown-minutes').html(minutes);
					$(element).find('.ets-mm-countdown-seconds').html(seconds);

					// If the count down is finished, write some text
					if (distance < 0) {
						clearInterval(clockInterval);
						$(element).html('EXPIRED');
					}
				}, 1000);
			},
			flipClock: {
				flipTo: function (digit, n) {
					var current = digit.attr('data-num');
					digit.attr('data-num', n);
					digit.find('.front').attr('data-content', current);
					digit.find('.back, .under').attr('data-content', n);
					digit.find('.flap').css('display', 'block');
					setTimeout(function () {
						digit.find('.base').text(n);
						digit.find('.flap').css('display', 'none');
					}, 350);
				},

				jumpTo: function (digit, n) {
					digit.attr('data-num', n);
					digit.find('.base').text(n);
				},

				updateGroup: function (el, group, n, flip) {
					var digit1 = $(el).find('.ten' + group);
					var digit2 = $(el).find('.' + group);
					n = String(n);
					if (n.length == 1) n = '0' + n;
					var num1 = n.substr(0, 1);
					var num2 = n.substr(1, 1);
					if (digit1.attr('data-num') != num1) {
						if (flip) etsMM.flipClock.flipTo(digit1, num1);
						else etsMM.flipClock.jumpTo(digit1, num1);
					}
					if (digit2.attr('data-num') != num2) {
						if (flip) etsMM.flipClock.flipTo(digit2, num2);
						else etsMM.flipClock.jumpTo(digit2, num2);
					}
				},

				setTime: function (el, flip, time) {
					time = time.replace(/\-/g, '/');
					var countDownDate = new Date(time).getTime();
					// Get today's date and time
					var now = new Date().getTime();
					// Find the distance between now and the count down date
					var distance = countDownDate - now;
					if (distance <= 0) {
						$(el).html('');
						return;
					}

					// Time calculations for days, hours, minutes and seconds
					var days = Math.floor(distance / (1000 * 60 * 60 * 24));
					var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					var seconds = Math.floor((distance % (1000 * 60)) / 1000);

					etsMM.flipClock.updateGroup(el, 'day', days, flip);
					etsMM.flipClock.updateGroup(el, 'hour', hours, flip);
					etsMM.flipClock.updateGroup(el, 'min', minutes, flip);
					etsMM.flipClock.updateGroup(el, 'sec', seconds, flip);
				},
				init: function () {
					var flipBox = '<span class="base"></span>' +
						'<div class="flap over front"></div>' +
						'<div class="flap over back"></div>' +
						'<div class="flap under"></div>';

					$('.ets-mm-countdown').each(function () {

						$(this).removeClass('hide');
						var endDate = $(this).attr('data-datetime');
						var flip = $(this).attr('data-animate-type') == 'FLIP' ? true : false;
						var trans = {
							days: $(this).attr('data-trans-days'),
							hours: $(this).attr('data-trans-hours'),
							minutes: $(this).attr('data-trans-minutes'),
							seconds: $(this).attr('data-trans-seconds'),
						}
						var clockBox = etsMM.flipClock.appendClock(flipBox, flip, trans);
						$(this).html(clockBox);
						etsMM.flipClock.setTime(this, flip, endDate);
						var $this = this;
						setInterval(function () {
							etsMM.flipClock.setTime($this, flip, endDate);
						}, 1000);
					});
				},
				appendClock: function (flipBox, flip, trans) {
					return '<div class="clock ' + (flip ? 'flip-clock' : 'normal-clock') + '">' +
						'<div class="digits">' +
						'<div class="clock-group">' +
						'<div class="digit tenday">' + flipBox + '</div>' +
						'<div class="digit day">' + flipBox + '</div>' +
						'</div>' +
						'<div class="text">' + (trans.days) + '</div>' +
						'</div>' +
						'<div class="digits">' +
						'<div class="clock-group">' +
						'<div class="digit tenhour">' + flipBox + '</div>' +
						'<div class="digit hour">' + flipBox + '</div>' +
						'</div>' +
						'<div class="text">' + (trans.hours) + '</div>' +
						'</div>' +
						'<div class="digits">' +
						'<div class="clock-group">' +
						'<div class="digit tenmin">' + flipBox + '</div>' +
						'<div class="digit min">' + flipBox + '</div>' +
						'</div>' +
						'<div class="text">' + (trans.minutes) + '</div>' +
						'</div>' +
						'<div class="digits">' +
						'<div class="clock-group">' +
						'<div class="digit tensec">' + flipBox + '</div>' +
						'<div class="digit sec">' + flipBox + '</div>' +
						'</div>' +
						'<div class="text">' + (trans.seconds) + '</div>' +
						'</div>' +
						'</div>';
				}
			},

			createCss: function (ets_megamenu) {
				var html = '<style type="text/css">';
				html += 'li.ets_mm_menu_item_li.menu-item>.menu-item-link,.ets_mm_search button.ets_mm_submit_search,.ets_mm_menu_cart .ets_mm_cart_link{' +
					'line-height:' + ets_megamenu.settings.other_settings.menu_height + 'px;' +
					'min-height:' + ets_megamenu.settings.other_settings.menu_height + 'px;' +
					'}';
				if (ets_megamenu.settings.main_menu_item.main_menu_separator) {
					html += '.ets_mm_menu_item_li.menu-item{' +
						'            border-left: 1px solid ' + ets_megamenu.settings.main_menu_item.main_menu_separator + ';' +
						'            border-top: 1px solid ' + ets_megamenu.settings.main_menu_item.main_menu_separator + ';' +
						'}';
				}
				if (ets_megamenu.settings.tab_menu.tab_menu_separator) {
					html += '.ets_mm_menu_item_li li.tab-item{' +
						'            border-bottom: 1px solid ' + ets_megamenu.settings.tab_menu.tab_menu_separator + ';' +
						'        }';
				}
				html += '.ets_megamenu,.ets_megamenu.sticky-menu.sticky_fixed{' +
					(ets_megamenu.settings.main_menu_item.main_menu_background ? 'background-color:' + ets_megamenu.settings.main_menu_item.main_menu_background + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .menu-item-link{' +
					(ets_megamenu.settings.main_menu_item.main_menu_font ? 'font-family:' + ets_megamenu.settings.main_menu_item.main_menu_font + ', sans-serif;' : '') +
					(ets_megamenu.settings.other_settings.menu_height ? 'line-height:' + ets_megamenu.settings.other_settings.menu_height + 'px;' : '') +
					(ets_megamenu.settings.main_menu_item.main_menu_font_size ? 'font-size:' + ets_megamenu.settings.main_menu_item.main_menu_font_size + 'px;' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .menu-item-header-title{' +
					(ets_megamenu.settings.main_menu_item.main_menu_text ? 'color:' + ets_megamenu.settings.main_menu_item.main_menu_text + ';' : '') +
					(ets_megamenu.settings.main_menu_item.main_menu_text ? 'fill:' + ets_megamenu.settings.main_menu_item.main_menu_text + ';' : '') +
					'    }';
				html += '@media (max-width: 991px) { .ets_megamenu.mm-mobile .menu-item.has_subs .btn-toggle-item:after {' +
					(ets_megamenu.settings.main_menu_item.main_menu_text ? 'border-top-color:' + ets_megamenu.settings.main_menu_item.main_menu_text + ';' : '') +
					(ets_megamenu.settings.main_menu_item.main_menu_text ? 'border-right-color:' + ets_megamenu.settings.main_menu_item.main_menu_text + ';' : '') +
					'    }}';
				html += '.ets_mm_menu_item_li .menu-item-link > .main-menu-item-text:after{' +
					(ets_megamenu.settings.main_menu_item.main_menu_text ? 'border-color:' + ets_megamenu.settings.main_menu_item.main_menu_text + ';' : '') +
					'}';
				html += '.menu-item.open .menu-item-header-title{' +
					(ets_megamenu.settings.main_menu_item.main_menu_text_hover ? 'color:' + ets_megamenu.settings.main_menu_item.main_menu_text_hover + ';' : '') +
					(ets_megamenu.settings.main_menu_item.main_menu_text_hover ? 'fill:' + ets_megamenu.settings.main_menu_item.main_menu_text_hover + ';' : '') +
					(ets_megamenu.settings.main_menu_item.main_menu_background_hover ? 'background-color:' + ets_megamenu.settings.main_menu_item.main_menu_background_hover + ';' : '') +
					'}';
				html += '.main-menu-item-background-active .menu-item.open .menu-item-header-title:before{' +
					(ets_megamenu.settings.main_menu_item.main_menu_background_hover ? 'background-color:' + ets_megamenu.settings.main_menu_item.main_menu_background_hover + ';' : '') +
					'}';
				html += '.menu-item.open .menu-item-header-title .main-menu-item-text:after,.ets_mm_menu_item_li.menu-item.open .menu-item-link + .btn-toggle-item:after{' +
					(ets_megamenu.settings.main_menu_item.main_menu_text_hover ? 'border-color:' + ets_megamenu.settings.main_menu_item.main_menu_text_hover + ';' : '') +
					'}';
				html += '.ets_mm_menu_item_li .tab-item > .ets-mm-tab-item-link{' +
					(ets_megamenu.settings.tab_menu.tab_menu_font ? 'font-family:' + ets_megamenu.settings.tab_menu.tab_menu_font + ', sans-serif;' : '') +
					(ets_megamenu.settings.tab_menu.tab_menu_font_size ? 'font-size:' + ets_megamenu.settings.tab_menu.tab_menu_font_size + 'px;' : '') +
					(ets_megamenu.settings.tab_menu.tab_menu_text ? 'color:' + ets_megamenu.settings.tab_menu.tab_menu_text + ';' : '') +
					(ets_megamenu.settings.tab_menu.tab_menu_text ? 'fill:' + ets_megamenu.settings.tab_menu.tab_menu_text + ';' : '') +
					(ets_megamenu.settings.tab_menu.tab_menu_background ? 'background-color:' + ets_megamenu.settings.tab_menu.tab_menu_background + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .tab-item.has-sub>.ets-mm-tab-item-link > .tab-menu-item-text:before, .ets_mm_menu_item_li .tab-item.has-sub>.ets-mm-tab-item-link + .btn-toggle-item:after{' +
					(ets_megamenu.settings.tab_menu.tab_menu_text ? 'border-color:' + ets_megamenu.settings.tab_menu.tab_menu_text + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .tab-item>.ets-mm-tab-item-link:hover,.ets_mm_menu_item_li .tab-item:hover>.ets-mm-tab-item-link,.ets_mm_menu_item_li .tab-item.open>.ets-mm-tab-item-link{' +
					(ets_megamenu.settings.tab_menu.tab_menu_text_hover ? 'color:' + ets_megamenu.settings.tab_menu.tab_menu_text_hover + ';' : '') +
					(ets_megamenu.settings.tab_menu.tab_menu_text_hover ? 'fill:' + ets_megamenu.settings.tab_menu.tab_menu_text_hover + ';' : '') +
					(ets_megamenu.settings.tab_menu.tab_menu_background_hover ? 'background-color:' + ets_megamenu.settings.tab_menu.tab_menu_background_hover + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .tab-item:hover>.btn-toggle-item:hover,.ets_mm_menu_item_li .tab-item.open>.btn-toggle-item{' +
					(ets_megamenu.settings.tab_menu.tab_menu_text_hover ? 'color:' + ets_megamenu.settings.tab_menu.tab_menu_text_hover + ';' : '') +
					(ets_megamenu.settings.tab_menu.tab_menu_text_hover ? 'fill:' + ets_megamenu.settings.tab_menu.tab_menu_text_hover + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .tab-item>.ets-mm-tab-item-link:hover > .tab-menu-item-text:before,.ets_mm_menu_item_li .tab-item.open>.ets-mm-tab-item-link > .tab-menu-item-text:before,.ets_mm_menu_item_li .tab-item.open>.ets-mm-tab-item-link + .btn-toggle-item:after{' +
					(ets_megamenu.settings.tab_menu.tab_menu_text_hover ? 'border-color:' + ets_megamenu.settings.tab_menu.tab_menu_text_hover + ';' : '') +
					'    }';
				html += '.ets_megamenu .submenu-item-heading{' +
					(ets_megamenu.settings.sub_menu.submenu_menu_heading_font ? 'font-family:' + ets_megamenu.settings.sub_menu.submenu_menu_heading_font + ', sans-serif;' : '') +
					(ets_megamenu.settings.sub_menu.submenu_menu_heading_font_size ? 'font-size:' + ets_megamenu.settings.sub_menu.submenu_menu_heading_font_size + 'px;' : '') +
					(ets_megamenu.settings.sub_menu.sub_menu_heading_text ? 'color:' + ets_megamenu.settings.sub_menu.sub_menu_heading_text + ';' : '') +
					(ets_megamenu.settings.sub_menu.sub_menu_heading_bottom_line ? 'border-bottom-color:' + ets_megamenu.settings.sub_menu.sub_menu_heading_bottom_line + ';' : '') +
					'    }';
				html += '.ets_megamenu .submenu-item-heading:hover{' +
					(ets_megamenu.settings.sub_menu.sub_menu_heading_text_hover ? 'color:' + ets_megamenu.settings.sub_menu.sub_menu_heading_text_hover + ';' : '') +
					(ets_megamenu.settings.sub_menu.sub_menu_heading_bottom_line_hover ? 'border-bottom-color:' + ets_megamenu.settings.sub_menu.sub_menu_heading_bottom_line_hover + ';' : '') +
					'    }';
				html += '.ets_megamenu .submenu-item-content,.ets_megamenu .submenu-item-content div,' +
					'    .ets_megamenu .submenu-item-content span,' +
					'    .ets_megamenu .submenu-item-content p {' +
					(ets_megamenu.settings.sub_menu.submenu_menu_text_font ? 'font-family: ' + ets_megamenu.settings.sub_menu.submenu_menu_text_font + ', sans-serif;' : '') +
					(ets_megamenu.settings.sub_menu.submenu_text_font_size ? 'font-size: ' + ets_megamenu.settings.sub_menu.submenu_text_font_size + 'px;' : '') +
					(ets_megamenu.settings.sub_menu.sub_menu_text ? 'color: ' + ets_megamenu.settings.sub_menu.sub_menu_text + ';' : '') +
					'    }';
				if (ets_megamenu.settings.sub_menu.sub_menu_link) {
					html += '.ets_megamenu .submenu-item-content a{' +
						'        color: ' + ets_megamenu.settings.sub_menu.sub_menu_link + ';' +
						'    }';
				}
				if (ets_megamenu.settings.sub_menu.sub_menu_link_hover) {
					html += '.ets_megamenu .submenu-item-content a:hover{' +
						'        color: ' + ets_megamenu.settings.sub_menu.sub_menu_link_hover + ';' +
						'    }';
				}
				if (ets_megamenu.settings.sub_menu.sub_menu_background) {
					html += '.ets_megamenu .list-columns{' +
						'        background-color: ' + ets_megamenu.settings.sub_menu.sub_menu_background + ';' +
						'    }';
				}
				if (ets_megamenu.settings.main_tab_menu) {
					html += '.menu-item.is_menu_tabs .menu-item-header-title{' +
						'        background-color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_background + ';' +
						'        color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text + ';' +
						'        fill: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text + ';' +
						'    }';
					html += '.menu-item.is_menu_tabs .menu-item-header-title .main-menu-item-text:after{' +
						'        border-color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text + ';' +
						'    }';
					html += '.menu-item.is_menu_tabs.open .menu-item-header-title{' +
						'        background-color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_background_hover + ';' +
						'        color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text_hover + ';' +
						'        fill: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text_hover + ';' +
						'    }';
					html += '.menu-item.is_menu_tabs.open .menu-item-header-title:before{' +
						'        background-color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_background_hover + ';' +
						'    }';
					html += '.menu-item.is_menu_tabs.open .main-menu-item-text:after,.menu-item.is_menu_tabs.open .menu-item-header-title .btn-toggle-item:after {' +
						'        border-color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text_hover + ';' +
						'    }';

					html += '.menu-item.is_menu_tabs .main-menu-item-text .menu-icon-font svg{' +
						'        color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text + '; fill: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text + ';' +
						'    }';
					html += '.menu-item.is_menu_tabs.open .menu-icon-font svg {' +
						'        color: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text_hover + '; fill: ' + ets_megamenu.settings.main_tab_menu.main_tab_menu_text_hover + ';' +
						'    }';
				}
				html += '.ets_mm_menu_item_li .block-product-item .product-title{' +
					(ets_megamenu.settings.product.product_name_font ? 'font-family:' + ets_megamenu.settings.product.product_name_font + ';' : '') +
					(ets_megamenu.settings.product.product_name_font_size ? 'font-size:' + ets_megamenu.settings.product.product_name_font_size + 'px;' : '') +
					(ets_megamenu.settings.product.product_name_color ? 'color:' + ets_megamenu.settings.product.product_name_color + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .block-product-item .product-title:hover{' +
					(ets_megamenu.settings.product.product_name_hover ? 'color:' + ets_megamenu.settings.product.product_name_hover + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .block-product-item .product-price .price-compare,' +
					'    .ets_mm_menu_item_li .block-product-item .product-price .price-sell{' +
					(ets_megamenu.settings.product.product_price_font ? 'font-family:' + ets_megamenu.settings.product.product_price_font + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .block-product-item .product-price .price-compare{' +
					(ets_megamenu.settings.product.product_old_price_size ? 'font-size:' + ets_megamenu.settings.product.product_old_price_size + 'px;' : '') +
					(ets_megamenu.settings.product.product_old_price_color ? 'color:' + ets_megamenu.settings.product.product_old_price_color + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .block-product-item .product-price .price-sell{\n' +
					(ets_megamenu.settings.product.product_selling_price_size ? 'font-size:' + ets_megamenu.settings.product.product_selling_price_size + 'px;' : '') +
					(ets_megamenu.settings.product.product_selling_price_color ? 'color:' + ets_megamenu.settings.product.product_selling_price_color + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .block-contact-form button.btn.btn-primary{\n' +
					(ets_megamenu.settings.button.text_color ? 'color:' + ets_megamenu.settings.button.text_color + ';' : '') +
					(ets_megamenu.settings.button.background_color ? 'background-color:' + ets_megamenu.settings.button.background_color + '; border-color:' + ets_megamenu.settings.button.background_color + ';' : '') +
					'    }';
				html += '.ets_mm_menu_item_li .block-contact-form button.btn.btn-primary:hover{\n' +
					(ets_megamenu.settings.button.text_hover_color ? 'color:' + ets_megamenu.settings.button.text_hover_color + ';' : '') +
					(ets_megamenu.settings.button.background_hover_color ? 'background-color:' + ets_megamenu.settings.button.background_hover_color + '; border-color:' + ets_megamenu.settings.button.background_hover_color + ';' : '') +
					'    }';
				html += '</style>';
				return html;
			},
			createMegamenu: function (selector, isMenuMobile) {
				if (selector && selector.length > 1) {
					selector = selector.first();
				}
				isMenuMobile = isMenuMobile || false;
				var ets_megamenu = etsMM.ETS_MM_MENUS || null;
				if (!ets_megamenu) {
					return false;
				}
				var mmClass = '';

				if (ets_megamenu.settings.sticky_menu) {
					if (ets_megamenu.settings.sticky_menu.enable_sticky) {
						mmClass += ' sticky-menu';
					}
					if (ets_megamenu.settings.sticky_menu.hide_sticky) {
						mmClass += ' hide-sticky-menu-on-mobile';
					}
					if (ets_megamenu.settings.sticky_menu.center_item) {
						mmClass += ' sticky-menu-center';
					}
				}

				if (ets_megamenu.settings.main_menu_item && ets_megamenu.settings.main_menu_item.main_menu_background_hover && ets_megamenu.settings.main_menu_item.main_menu_background_hover != "") {
					mmClass += ' main-menu-item-background-active';
				}

				if (ets_megamenu.settings.other_settings.enable_grey) {
					mmClass += ' overlay-bg-grey';
				}
				if (ets_megamenu.settings.transition.menu) {
					mmClass += ' transition_menu_' + ets_megamenu.settings.transition.menu.toLowerCase();
				}
				if (ets_megamenu.settings.transition.mobile) {
					mmClass += ' transition_mobile_' + ets_megamenu.settings.transition.mobile.toLowerCase();
				}

				selector.parent().addClass('ets_megamenu ' + mmClass);
				if (selector.parent().hasClass('ets_mm_embeddedcode')) {

					if (!selector.parent().find('.ets-mm-toggle-menu-mobile').length) {
						var textMenu = '';
						if (typeof ets_megamenu.settings.mobile !== 'undefined' && ets_megamenu.settings.mobile.title_menu != "" && etsMM.isMobile()) {
							textMenu = '<span class="ets-menu-text-embedded ' + (etsMM.isMobile() ? '' : ' ets-mm-hidden') + '">' + ets_megamenu.settings.mobile.title_menu + '</span>';
						}
						selector.parent().prepend('<button class="ets-mm-toggle-menu-mobile js-ets-mm-toggle-menu-mobile' + (etsMM.isMobile() ? '' : ' ets-mm-hidden') + '">' +
							'<span class="icon-menu-toggle"></span>' +
							'<span class="icon-menu-toggle"></span>' +
							'<span class="icon-menu-toggle"></span>' +
							'</button>' + textMenu);
					}
				}

				if (etsMM.isMobile()) {
					selector.parent().addClass('mm-mobile');
				}
				selector.addClass('list-menus').find('li').addClass('ets_mm_item_disabled');

				if (typeof ets_megamenu.settings.other_settings.menu_width !== "undefined" && ets_megamenu.settings.other_settings.menu_width != "") {
					if (ets_megamenu.settings.other_settings.menu_width === 'fixed') {
						if (typeof ets_megamenu.settings.other_settings.menu_width_fixed !== "undefined" && ets_megamenu.settings.other_settings.menu_width_fixed != "") {
							selector.css('width', ets_megamenu.settings.other_settings.menu_width_fixed + 'px');
						} else {
							selector.css('width', '1200px');
						}
					} else {
						selector.css('width', 'auto');
					}
				}
				if (ets_megamenu.menus) {
					var menuItems = '';
					var styleMenu = '';
					if (typeof ets_megamenu.settings.transition.mobile !== 'undefined' && (ets_megamenu.settings.transition.mobile == 'fullscreen' || ets_megamenu.settings.transition.mobile == 'right' || ets_megamenu.settings.transition.mobile == 'floating') && typeof ets_megamenu.settings.menu_mobile !== 'undefined' && typeof ets_megamenu.settings.menu_mobile.background_header_color !== 'undefined' && ets_megamenu.settings.menu_mobile.background_header_color != '') {
						styleMenu = 'background-color: ' + ets_megamenu.settings.menu_mobile.background_header_color;
					}
					menuItems += '<li class="ets-item-header-mobile" style="' + styleMenu + '" ><span class="m_left">';
					menuItems += '<i class="ets_svg icon_bars"><svg width="16" height="16" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"></path></svg></i>';
					if (typeof ets_megamenu.settings.mobile.title_menu !== 'undefined' && ets_megamenu.settings.mobile.title_menu != '') {
						menuItems += ets_megamenu.settings.mobile.title_menu + ' ';
					} else {
						menuItems += '&nbsp;';
					}
					menuItems += '</span>';
					menuItems += '<span class="ets-close-mobile js-ets-mm-close-mobile"><i class="ets_svg icon_angle_left"><svg width="18" height="18" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"></path></svg></i>';
					if (typeof ets_megamenu.settings.mobile.title_back_btn !== 'undefined' && ets_megamenu.settings.mobile.title_back_btn != '') {
						menuItems += ets_megamenu.settings.mobile.title_back_btn;
					}
					menuItems += '<i class="ets_svg icon_angle_right"><svg width="18" height="18" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"></path></svg></i></span>';
					menuItems += '</li>';
					$.each(ets_megamenu.menus, function (i, item) {
						menuItems += etsMM.createMenuItem(item, i, isMenuMobile);
					});


					selector.append(etsMM.createFontLinks(ets_megamenu) + etsMM.createCss(ets_megamenu) + menuItems);
					if (ets_megamenu.settings.sticky_menu && ets_megamenu.settings.sticky_menu.enable_sticky && !selector.parent().prev('.ets_mm_height_sticky').length) {
						selector.parent().after('<div class="ets_mm_height_sticky"></div>');
					}
				}
			},
			createMenuItem: function (menu, index, isMenuMobile) {
				// console.log('menu',menu);
				var ets_megamenu = etsMM.ETS_MM_MENUS || null;
				// console.log('ets_megamenu',ets_megamenu);
				let check_has_subs = false;
				var mmClass = '';
				if (menu.menu_direction == 1) {
					mmClass += ' is_menu_tabs';
					mmClass += menu.tabs && menu.tabs && menu.tabs.length > 0 ? ' has_subs' : '';
					mmClass += menu.open_vertical_menu ? " open-vertical-menu" : menu.open_vertical_first_tab_menu ? " open-vertical-first-tab-menu static-open-vertical-first-menu" : "";
					mmClass += !isMenuMobile ? " static-open-vertical-first-menu open-vertical-first-tab-menu " : " static-open-vertical-first-menu "

					if (menu.tabs && menu.tabs && menu.tabs.length > 0) {
						check_has_subs = true;
					} else {
						check_has_subs = false;
					}
				}
				if (menu.menu_direction == 0 && menu.columns && menu.columns.length > 0) {
					mmClass += ' arrow-item has_subs';
					check_has_subs = true;
				}
				if (menu.submenu_alignment == 'left') {
					mmClass += ' align-left';
				} else if (menu.submenu_alignment == 'right') {
					mmClass += ' align-right';
				} else {
					mmClass += ' align-auto';
				}
				var menuLink = '';

				switch (menu.menu_link_type) {
					case 'HOME':
						menuLink = '/';
						break;
					case 'SEARCH':
						menuLink = '/search';
						break;
					case 'COLLECTION':
						menuLink = menu.custom_link;
						break;
					case 'BLOG':
						menuLink = menu.custom_link;
						break;
					case 'PAGE':
						menuLink = menu.custom_link;
						break;
					case 'CUSTOM':
						menuLink = menu.custom_link;
				}

				var style = '';

				var styleInline = '';
				if (typeof menu.menu_width !== 'undefined') {
					styleInline += 'width:' + menu.menu_width + 'px;';
				}

				var html = '<li class="menu-item menu-item-header js-ets-mm-menu-item-hover-open ets_mm_menu_item_li ' + mmClass + '" style="' + styleInline + '">';

				var tagLink = etsMM.isMobile() ? check_has_subs == false ? 'a' : ets_megamenu.settings.mobile.open_submenu == false ? 'a' : "span" : "a";
				if (!menuLink) {
					tagLink = 'span';
				}
				// console.log('check_has_subs',check_has_subs);
				var classTitleTextBold = menu.bold_title ? " ets-text-bold" : "";
				html += style;
				html += '<div class="menu-item-header-title">';
				html += '<' + tagLink + ' id="ets-mm-menu-item--link-m' + index + '" class="menu-item-link js-ets-mm-inner-text-menu-item ' + classTitleTextBold + '" ' + (tagLink == 'a' ? 'href="' + menuLink + '" ' : '') + ' ' + (menu.link_in_new_tab ? ' target="_blank"' : '') + '>';
				html += '<span class="main-menu-item-text" style="' + (menu.uppercase ? 'text-transform: uppercase;' : '') + '">';
				html += (menu.menu_icon_font ? '<i class="menu-icon menu-icon-font menu-item-icon icon-svg ' + menu.icon_font_field + '">' + menu.icon_svg + '</i>' : '');
				html += (menu.menu_icon_image ? '<i class="menu-icon menu-icon-img"><img class="icon-img" src="' + menu.icon_image_field + '" align="menu-icon" /></i>' : '');
				html += (menu.enable_badge ? '<span class="menu-badge mm_bubble_text" style="background-color: ' + menu.badge_background + ';color: ' + menu.badge_color + ';">' + menu.badge_text + '</span>' : '');
				html += menu.title;
				html += '</span>';

				html += '</' + tagLink + '>';
				html += ((menu.menu_direction == 1 && menu.tabs && menu.tabs.length > 0) || (menu.menu_direction == 0 && menu.columns && menu.columns.length > 0) ? '<span class="btn-toggle-item js-ets-mm-btn-toggle-item"><i class="ets_svg"><svg width="18" height="18" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"></path></svg></i></span>' : '');
				html += '</div>';
				var menuStyle = '';

				if (menu.background) {
					menuStyle += 'background-image: url(\'' + menu.background_image + '\');';
					menuStyle += 'background-position: ' + menu.background_position + ';';
					menuStyle += 'background-size: ' + menu.background_size + ';';
				}
				if (menu.submenu_alignment == 'left') {
					menuStyle += 'float:left;';
				}
				if (menu.submenu_alignment == 'right') {
					menuStyle += 'float:left;';
				}

				if (menu.submenu_alignment == 'auto') {
					menuStyle += 'margin:0 auto;';
				}

				var menuWidth = 0;
				if (typeof ets_megamenu.settings.other_settings.menu_width !== 'undefined' && ets_megamenu.settings.other_settings.menu_width === 'fixed'
					&& typeof ets_megamenu.settings.other_settings.menu_width_fixed !== 'undefined' && ets_megamenu.settings.other_settings.menu_width_fixed) {
					menuWidth = ets_megamenu.settings.other_settings.menu_width_fixed;
					var menuWidthCalc = parseInt(ets_megamenu.settings.other_settings.menu_width) * parseInt(menu.sub_menu_width) / 100;
					//menuStyle += 'width:' + menuWidthCalc + 'px;';
				}
				if (menuWidth && menu.submenu_alignment == 'auto') {
					menuStyle += 'width:' + menuWidth + 'px;';
				} else {
					menuStyle += 'width:' + menu.sub_menu_width + '%;';
				}
				menuStyle += 'max-width: 100vw';
				if (menu.menu_direction == 1) {
					if (menu.tabs && menu.tabs.length) {
						html += '<ul class="list-tabs" data-width="' + menuWidth + '" style="' + menuStyle + '">';
						$.each(menu.tabs, function (i, tab) {
							html += etsMM.createTabItem(tab, i, menu, index);
						});
						html += '</ul>';
					}
				} else {
					if (menu.columns && menu.columns.length) {
						html += '<ul class="list-columns" data-width="' + menuWidth + '" style="' + menuStyle + '">';
						html += '<li class="menu_header_title_sub">';
						html += '<span class="back_to_item js-ets-mm-back-item">';
						html += '<svg width="16" height="16" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1792 800v192q0 14-9 23t-23 9h-1248v224q0 21-19 29t-35-5l-384-350q-10-10-10-23 0-14 10-24l384-354q16-14 35-6 19 9 19 29v224h1248q14 0 23 9t9 23z"/></svg>';
						html += menu.title;
						html += '</span>';
						html += '<span class="close_menu js-ets-mm-close-sub-menu">' +
							'<svg width="20" height="20" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"></path></svg>' +
							'</span>';
						html += '</li>';
						$.each(menu.columns, function (i, col) {
							html += etsMM.createColumnItem(col, i);
						});
						html += '</ul>';
					}
				}
				html += '</li>';
				return html;
			},
			createColumnItem: function (col, index) {
				var html = (col.is_break ? '<li class="break-col"></li>' : '') + '<li class="col-item menu-column mm-menu-column-container mm-col-' + (col.column_size) + '">';
				if (col.blocks && col.blocks.length) {
					html += '<ul class="list-blocks menu-column-blocks">';
					$.each(col.blocks, function (i, block) {
						html += etsMM.createBlockItem(block, i);
					});
					html += '</ul>';
				}
				html += '</li>';
				return html;
			},
			createBlockItem: function (block, index) {
				var idBlock = 'ets-mm-block-' + etsMM.randId();

				var style = '<style type="text/css">' +
					'#' + idBlock + ' .block-content *{' + (block.text_font_size ? 'font-size:' + block.text_font_size + 'px;' : '') + (block.text_font ? 'font-family:\'' + block.text_font + '\';' : '') + '}' +
					'</style>';
				var html = '<li class="block-item submenu-item menu-column-blocks-item" id="' + idBlock + '">';
				html += style;
				html += '<div class="block-wrapper">';
				var tagLink = 'a';
				if (!block.title_link) {
					tagLink = 'span';
				}
				if (block.toggle_title) {
					var classTitleTextBold = block.bold_title ? " ets-text-bold" : "";
					html += '<' + tagLink + ' class="block-title submenu-item-heading ' + (block.uppercase ? ' ets_text_uppercase' : '') + (block.enable_heading_divider ? ' ets_enable_heading_divider' : '') + classTitleTextBold + ' "' + ' ' + (tagLink == 'a' ? ' href="' + block.title_link + '" ' : '') + '>' + block.title + '</' + tagLink + '>';
				}
				html += '<div class="block-content submenu-item-content">';
				if (block.menu_link_type == 'BLOCK_HTML') {
					if (block.html.show_countdown) {
						if (block.html.countdown_position == 'AFTER') {
							html += '<div class="html-content">' + etsMM.nl2br(block.html.html_content) + '</div>';
						}
						var cRandId = etsMM.randId();
						var countdownId = 'etsMMCountdown_' + cRandId;
						var keyFrameFrontName = 'etsMMCountdownKeyFrameFront' + cRandId;
						var keyFrameBackName = 'etsMMCountdownKeyFrameBack' + cRandId;
						var keyFrameUnderName = 'etsMMCountdownKeyFrameUnder' + cRandId;

						html += '<div class="ets-mm-countdown ' + (block.html.countdown_alignment ? ' alignment-' + block.html.countdown_alignment : ' alignment-center') + '" id="' + countdownId + '"' +
							' data-text_color="' + block.html.countdown_number_color + '"' +
							' data-box_color="' + block.html.countdown_box_color + '"' +
							' data-datetime="' + block.html.datetime_end_countdown + '"' +
							' data-animate-type="' + block.html.countdown_type + '"' +
							' data-trans-days="' + (block.html.translate_days ? block.html.translate_days : '') + '"' +
							' data-trans-hours="' + (block.html.translate_hours ? block.html.translate_hours : '') + '"' +
							' data-trans-minutes="' + (block.html.translate_minutes ? block.html.translate_minutes : '') + '"' +
							' data-trans-seconds="' + (block.html.translate_seconds ? block.html.translate_seconds : '') + '"' +
							'>' + block.html.datetime_end_countdown + '</div>';
						if (block.html.countdown_position == 'BEFORE') {
							html += '<div class="html-content">' + etsMM.nl2br(block.html.html_content) + '</div>';
						}

						html += '<style media="screen" type="text/css">' +
							'#' + countdownId + '[data-animate-type="FLIP"] .flap,#' + countdownId + '[data-animate-type="FLIP"] .clock .digit{background-color: ' + block.html.countdown_box_color + ';}' +
							'#' + countdownId + '[data-animate-type="NORMAL"] .digits{border: 1px solid ' + block.html.countdown_box_color + ';}' +
							'#' + countdownId + '[data-animate-type="FLIP"] .clock-group:not(:last-child):after{color: ' + block.html.countdown_number_color + ';}' +
							'#' + countdownId + '[data-animate-type="FLIP"] .clock .base,#' + countdownId + '[data-animate-type="FLIP"] .clock .clock-group:not(:last-child):before{color: ' + block.html.countdown_number_color + ';}' +
							'#' + countdownId + '[data-animate-type="FLIP"] .flap.front{animation: ' + keyFrameFrontName + ' 300ms ease-in both;}' +
							'#' + countdownId + '[data-animate-type="FLIP"] .flap.back{animation: ' + keyFrameBackName + ' 300ms ease-in both;}' +
							'#' + countdownId + '[data-animate-type="FLIP"] .flap.under{animation: ' + keyFrameUnderName + ' 300ms ease-in both;}' +
							'@keyframes ' + keyFrameFrontName + '{0% {' +
							'transform: scaleY(0.9) skewX(0deg);' +
							'background-color: ' + block.html.countdown_box_color + ';' +
							'color: ' + block.html.countdown_number_color + ';' +
							'}' +
							'100% {' +
							'transform: scaleY(0) skewX(20deg);' +
							'background-color: ' + etsMM.shadeColor(block.html.countdown_box_color, -30) + ';' +
							'color: ' + block.html.countdown_number_color + ';' +
							'}}' +
							'@keyframes ' + keyFrameBackName + ' {' +
							'0% {' +
							'transform: rotateY(180deg) rotateX(0deg);' +
							'background-color: ' + etsMM.shadeColor(block.html.countdown_box_color, -30) + ';' +
							'color: ' + block.html.countdown_number_color + ';' +
							'}' +
							'100% {' +
							'transform: rotateY(180deg) rotateX(180deg);' +
							'background-color: ' + block.html.countdown_box_color + ';' +
							'color: ' + block.html.countdown_number_color + ';' +
							'}' +
							'}' +
							'@keyframes ' + keyFrameUnderName + ' {' +
							'0% {' +
							'background-color: ' + etsMM.shadeColor(block.html.countdown_box_color, -30) + ';' +
							'color: ' + block.html.countdown_number_color + ';' +
							'}' +
							'100% {' +
							'background-color: ' + block.html.countdown_box_color + ';' +
							'color: ' + block.html.countdown_number_color + ';' +
							'}' +
							'}' +
							'</style>';
					} else {
						html += '<div class="html-content">' + etsMM.nl2br(block.html.html_content) + '</div>';
					}
				} else if (block.menu_link_type == 'BLOCK_IMAGE') {
					html += '<div class="image-wrapper">' +
						(block.images.image_link ? '<a href="' + block.images.image_link + '" class="ets-mm-img-block-link">' : '') +
						'<img src="' + block.images.url + '" class="mm-block-img" />' +
						(block.images.image_link ? '</a>' : '') +
						'</div>';
				} else if (block.menu_link_type == 'BLOCK_COLLECTION') {
					html += '<ul class="block-collection">';
					if (!block.collections || !block.collections.collections || !block.collections.collections.length) {
						html += '<li className="item-empty"><span className="not-available">No collection available</span></li>';
					} else {
						$.each(block.collections.collections, function (ic, collection) {
							var linkCollection = collection.value;
							// if (linkCollection.indexOf('https://') === -1) {
							// 	linkCollection = '/collections/' + linkCollection;
							// }
							// html += '<li><a href="' + linkCollection + '">' + collection.label + '</a> </li>';

							if (typeof linkCollection != 'undefined') {
								if (linkCollection.indexOf('https://') === -1) {
									linkCollection = '/collections/' + linkCollection;
								}
								html += '<li><a href="' + linkCollection + '">' + collection.label + '</a> </li>';
							} else {
								console.log('linkCollection', block.collections);
							}

						});
					}

					html += '</ul>';
				} else if (block.menu_link_type == 'BLOCK_PAGE') {

					html += '<ul class="block-page">';
					if (!block.pages || !block.pages.pages || !block.pages.pages.length) {
						html += '<li className="item-empty"><span className="not-available">No page available</span></li>';
					} else {
						$.each(block.pages.pages, function (ic, page) {
							var linkPage = page.value;
							if (linkPage.indexOf('https://') === -1) {
								linkPage = '/pages/' + linkPage;
							}
							html += '<li><a href="' + linkPage + '">' + page.label + '</a> </li>';
						});
					}

					html += '</ul>';
				} else if (block.menu_link_type == 'BLOCK_BLOG') {

					html += '<ul class="block-blog">';
					if (!block.blogs || !block.blogs.blogs || !block.blogs.blogs.length) {
						html += '<li className="item-empty"><span className="not-available">No blog available</span></li>';
					} else {
						$.each(block.blogs.blogs, function (ic, blog) {
							var linkBlog = blog.value;
							if (linkBlog.indexOf('https://') === -1) {
								linkBlog = '/blogs/' + linkBlog;
							}
							html += '<li><a href="' + linkBlog + '">' + blog.label + '</a> </li>';
						});
					}

					html += '</ul>';
				} else if (block.menu_link_type == 'BLOCK_BLOG_POST') {
					html += '<ul class="block-blog-post">';
					if (!block.articles || !block.articles.articles || !block.articles.articles.length) {
						html += '<li className="item-empty"><span className="not-available">No blog post available</span></li>';
					} else {
						$.each(block.articles.articles, function (ic, article) {
							html += '<li>' +
								'<div class="blog-post-img"><a href="' + article.handle + '">' +
								(article.image ? '<img src="' + article.image.src + '" alt="' + (article.image.alt ? article.image.alt : article.title) + '" /> ' : '<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>') +
								'</a></div>' +
								'<div class="blog-post-content"><a href="' + article.handle + '">' + article.title + '</a></div>' +
								'</li>';
						});
					}

					html += '</ul>';
				} else if (block.menu_link_type == 'BLOCK_PRODUCT') {
					html += '<ul class="block-product">';
					if (!block.products || !block.products.collection_products || !block.products.collection_products.length) {
						html += '<li className="item-empty"><span className="not-available">No product available</span></li>';
					} else {
						$.each(block.products.collection_products, function (ic, product) {
							html += '<li class="block-product-item">';
							html += '<div class="product-wrapper">';
							html += '<div class="product-img">';
							html += '<a href="/products/' + product.handle + '">';
							html += (product.image ? '<img src="' + product.image + '" alt="' + product.title + '" />' : '<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>');
							html += '</a>';
							html += '</div>';
							html += '<div class="product-info">';
							html += '<div class="product-title">';
							html += '<a href="/products/' + product.handle + '">' + product.title + '';
							html += '</a></div>';
							html += '<div class="product-price">';
							if (product.compare_at_price) {
								html += '<span class="price-compare">' + etsMM.displayPrice(product.compare_at_price) + '</span>';
							}
							html += '<span class="price-sell">' + etsMM.displayPrice(product.price) + '</span>';
							html += '</div>';
							html += '</div>';
							html += '</div>';
							html += '</li>';
						});
					}

					html += '</ul>';
				} else if (block.menu_link_type == 'BLOCK_CONTACT') {
					html += '<div class="block-contact-form">' +
						'     <form action="/contact#ContactForm" accept-charset="UTF-8" method="post" autocomplete="none">' +
						'<input type="hidden" name="form_type" value="contact">' +
						'<input type="hidden" name="utf8" value="✓">' +
						'         <div class="form-group">' +
						'             <input type="text" class="form-control" name="contact[Name]" value="" autocomplete="' + etsMM.randId() + '" placeholder="' + block.contact_form.contact_name + '" />' +
						'         </div>' +
						'         <div class="form-group">' +
						'             <input type="text" class="form-control" name="contact[email]" value="" autocomplete="' + etsMM.randId() + '" placeholder="' + block.contact_form.contact_email + '" />' +
						'         </div>' +
						'         <div class="form-group">' +
						'             <input type="text" class="form-control" name="contact[Phone Number]" autocomplete="' + etsMM.randId() + '" pattern="[0-9\\-]*" value="" placeholder="' + block.contact_form.contact_phone_number + '" />' +
						'         </div>' +
						'         <div class="form-group">' +
						'             <textarea class="form-control" name="contact[Message]" autocomplete="' + etsMM.randId() + '" placeholder="' + block.contact_form.contact_message + '" style="resize: none;"></textarea>' +
						'         </div>' +
						'         <div class="form-group">' +
						'             <button type="submit" class="btn btn-primary">' + block.contact_form.contact_submit + '</button>' +
						'         </div>' +
						'     </form>' +
						' </div>';
				}
				html += '</div>';
				html += '</div>';
				html += '</li>';
				return html;
			},
			createTabItem: function (tab, index, menu, menuIndex) {
				var tabLink = '';
				switch (tab.tab_link_type) {
					case 'HOME':
						tabLink = '/';
						break;
					case 'SEARCH':
						tabLink = '/search';
						break;
					case 'COLLECTION':
						tabLink = tab.custom_link ? tab.custom_link : '/collections';
						break;
					case 'BLOG':
						tabLink = tab.custom_link ? tab.custom_link : '/blogs';
						break;
					case 'PAGE':
						tabLink = tab.custom_link ? tab.custom_link : '/pages';
						break;
					case 'CUSTOM':
						tabLink = tab.custom_link;
				}
				var html = '<li class="tab-item js-ets-mm-tab-item-hover-open ' + (tab.columns && tab.columns.length ? 'arrow-item has-sub' : '') + ' ' + (tab.display_content_tab ? ' ' : 'sub_menu_top') + '" style="width:' + menu.sub_tab_width + 'px;">';
				var styleTab = '';
				var tagLink = 'a';
				if (!tabLink) {
					tagLink = 'span';
				}
				var classTitleTextBold = tab.bold_title ? " ets-text-bold" : "";
				html += '<' + tagLink + ' class="ets-mm-tab-item-link ' + classTitleTextBold + '" id="ets-mm-tab-item--link-m' + menuIndex + '_t' + index + '"' + (tagLink == 'a' ? 'href="' + tabLink + '" ' : '') + '' + (tab.link_in_new_tab ? ' target="_blank"' : '') + ' style="' + styleTab + '">';

				html += '<span class="tab-menu-item-text" style="' + (tab.uppercase ? 'text-transform: uppercase;' : '') + '">';
				if (tab.tab_icon_font) {
					html += '<i class="tab-icon tab-icon-font icon-svg ' + tab.icon_font_field + '">' + tab.icon_svg + '</i>';
				} else if (tab.tab_icon_image) {
					html += '<i class="tab-icon tab-icon-img"><img class="icon-img" src="' + tab.icon_image_field + '" alt="tab-icon" /></i>';
				}
				html += tab.title + '</span>';
				if (tab.enable_badge) {
					html += '<span class="tab-badge " style="background-color: ' + tab.badge_background + '; color: ' + tab.badge_color + ';">' + tab.badge_text + '</span>';
				}
				html += '</' + tagLink + '>';
				if (tab.columns && tab.columns.length) {
					html += '<span class="btn-toggle-item js-ets-mm-btn-toggle-item_tab"><i class="ets_svg"><svg width="18" height="18" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"></path></svg></i></span>';
					html += '<ul class="list-columns tab-columns ' + (tab.display_content_tab ? ' from_top' : '') + ' " style="width:calc(100% - ' + menu.sub_tab_width + 'px);left:' + menu.sub_tab_width + 'px;' + (tab.background && tab.background_image ? 'background-image: url(\'' + tab.background_image + '\'); background-position: bottom; background-repeat: no-repeat;' : '') + '">';
					html += '<li class="menu_header_title_sub"><span class="back_to_item js-ets-mm-back-item"><svg width="16" height="16" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1792 800v192q0 14-9 23t-23 9h-1248v224q0 21-19 29t-35-5l-384-350q-10-10-10-23 0-14 10-24l384-354q16-14 35-6 19 9 19 29v224h1248q14 0 23 9t9 23z"></path></svg>' + tab.title + '</span><span class="close_menu js-ets-mm-close-sub-menu"><svg width="20" height="20" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"></path></svg></span></li>';
					$.each(tab.columns, function (i, col) {
						html += etsMM.createColumnItem(col, i);
					});
					html += '</ul>';
				}
				html += '</li>';
				return html;
			},

			createFontLinks: function (ets_megamenu) {
				if (ets_megamenu.fonts && ets_megamenu.fonts.length) {
					var fonts = '';
					$.each(ets_megamenu.fonts, function (i, font) {
						if (font.trim()) {
							if (fonts == '') {
								fonts += encodeURI(font);
							} else {
								fonts += '|' + encodeURI(font);
							}
						}

					});
					if (fonts)
						return '<link href="https://fonts.googleapis.com/css?family=' + fonts + '" rel="stylesheet">';
				}
				return '';
			},
			displayPrice: function (price) {

				try {
					if (price == '0' || !price) {
						price = '0.00';
					} else {
						var priceFormat = price.toFixed(2);
						if (parseFloat(priceFormat) == parseFloat(price)) {
							price = priceFormat;
						}
					}

				} catch (e) {

				}
				return typeof ETS_MM_MONEY_FORMAT !== "undefined" && ETS_MM_MONEY_FORMAT ? ETS_MM_MONEY_FORMAT.replace(/(\{\{[^\}]+\}\})/g, price) : price;
			},
			randId: function () {
				return Math.floor(Math.random() * 1000000);
			},
			nl2br: function (str, is_xhtml) {
				if (typeof str === 'undefined' || str === null) {
					return '';
				}
				var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
				return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
			},
			setStyleOverlay: function () {
				if ($('.ets_megamenu.overlay-bg-grey').length) {
					var menuWidth = $('.ets_megamenu.overlay-bg-grey:visible').width();
					$('#etsMMStyleOverlay').remove();
					$('body').append('<style type="text/css" id="etsMMStyleOverlay">.ets_megamenu.overlay-bg-grey:before{left: calc((' + menuWidth + 'px - 100vw) / 2);}</style>');
				}
			},
			shadeColor: function (color, percent) {
				return color;
				var R = parseInt(color.substring(1, 3), 16);
				var G = parseInt(color.substring(3, 5), 16);
				var B = parseInt(color.substring(5, 7), 16);

				R = parseInt(R * (100 + percent) / 100);
				G = parseInt(G * (100 + percent) / 100);
				B = parseInt(B * (100 + percent) / 100);

				R = (R < 255) ? R : 255;
				G = (G < 255) ? G : 255;
				B = (B < 255) ? B : 255;

				var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
				var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
				var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

				return "#" + RR + GG + BB;
			}
		};


		function openMenu($this) {
			if (!etsMM.isMobile()) {
				if ($this.closest('.ets_megamenu.mm-mobile').length) {
					return;
				}

				var tab_item_length = parseInt($this.parents(".list-tabs").find('.tab-item').length);
				var tab_width = parseInt($this.width())
				var tab_height = parseInt($this.height());
				var tab_space_top = $this.position().top + 1 + tab_height;

				$this.find('.list-columns.tab-columns.from_top').css('min-height', tab_space_top + 'px');


				if (!$this.hasClass('open-vertical-first-tab-menu')) {
					$this.closest('.list-menus').find('.static-open-vertical-first-menu').removeClass('open-vertical-first-tab-menu')
				}

				$this.addClass('open');


				if ($this.hasClass('has_subs')) {
					$this.closest('.ets_megamenu.overlay-bg-grey').parents('body').addClass('active-overlay')
				}
				if ($(window).width() >= 992) {
					var pos_left = $('.ets_megamenu:not(.mm-mobile) .list-menus').offset().left;
					var mainmenu_w = $('.ets_megamenu:not(.mm-mobile) .list-menus').width();
					var menu_w = $('.ets_megamenu:not(.mm-mobile) .align-auto > .list-tabs, .ets_megamenu:not(.mm-mobile) .align-auto > .list-columns').outerWidth();
					var window_w = $(window).width();

					if ((window_w - menu_w) / 2 > pos_left) {
						var change_left = (window_w - menu_w) / 2 - pos_left;
					} else {
						var change_left = pos_left - (window_w - menu_w) / 2;
					}
					if ((pos_left + mainmenu_w) > (pos_left + menu_w)) {
						var change_left_2 = change_left - ((pos_left + mainmenu_w) - (pos_left + menu_w));
					} else {
						if ((pos_left + menu_w) > window_w) {
							if ((pos_left + menu_w) - (pos_left + mainmenu_w) > change_left) {
								var change_left_2 = change_left;
							} else {
								var change_left_2 = (pos_left + menu_w) - (pos_left + mainmenu_w);
							}

						} else {
							if (change_left > pos_left) {
								if ($(window).width < 1200) {
									var change_left_2 = pos_left;
								} else {
									var change_left_2 = pos_left - 10;
								}
							} else {
								var change_left_2 = change_left;
							}
						}
					}
					$('.ets_megamenu:not(.sticky_fixed) .align-auto > .list-columns,.ets_megamenu:not(.sticky_fixed) .align-auto > .list-tabs').css('margin-left', '-' + change_left_2 + 'px');
				} else {
					$('.ets_megamenu:not(.sticky_fixed) .align-auto > .list-columns,.ets_megamenu:not(.sticky_fixed) .align-auto > .list-tabs').css('margin-left', 'auto');
				}

			}
		}

		function closeMenu($this) {
			if (!etsMM.isMobile() && !$this.closest('.ets_megamenu').hasClass('menu_tablet')) {
				$this.removeClass('open').children('ul.list-columns:not(.tab-columns)').slideUp(50);
				$this.removeClass('open').children('ul.list-tabs').slideUp(50);

				if ($this.hasClass('has_subs')) {
					$this.closest('.ets_megamenu.overlay-bg-grey').parents('body').removeClass('active-overlay')
				}
				$this.closest('.list-menus').find('.static-open-vertical-first-menu').addClass('open-vertical-first-tab-menu');
			}
			$('.list-columns.tab-columns.from_top').css('min-height', '0');
		}

		$(document).ready(function () {
			etsMM.initMenu();
			etsMM.setStyleOverlay();
			$(document).scroll();


			$(window).resize(function () {
				if ($(window).width() < 992) {
					$('.menu-item > .list-tabs').css('margin-left', 'auto');
					$('.menu-item > .list-columns').css('margin-left', 'auto');
				}
			});

			$(document).on('mouseenter touchend', '.js-ets-mm-inner-text-menu-item', function () {
				if (!etsMM.isMobile()) {
					if (!$(this).parent('li').find('.list-tabs > .js-ets-mm-tab-item-hover-open.open').length && $(this).parent('li').hasClass('open') && $(this).parent('li').hasClass('is_menu_tabs')) {
						$(this).parent('li').find('.list-tabs > .js-ets-mm-tab-item-hover-open:first-child').addClass('open');
					}
				}
			});

			$(document).on('touchend', '.js-ets-mm-btn-toggle-item', function () {
				var $this = $(this);
				var hasOpen = $this.parents('li.menu-item').hasClass('open');
				console.log($this, hasOpen)

				if (!hasOpen) {
					$this.parents('li.menu-item').addClass('open');
					$this.parents('li.menu-item:not(.is_menu_tabs)').parents('.ets_megamenu').addClass('open_sub_leve2');
				} else {
					$this.parents('li.menu-item').removeClass('open');
					$this.parents('.ets_megamenu').removeClass('open_sub_leve2');
				}
				if ($('#PageContainer').length && !$('.ets_megamenu').hasClass('ets_mm_embeddedcode')) {
					var menuHeight = $('.ets_megamenu.mm-mobile').height();
					$('#PageContainer').css('transform', 'translate3d(0px, ' + menuHeight + 'px, 0px)');
				}
			});
			$(document).on('click touchend', '.js-ets-mm-inner-text-menu-item', function () {
				var ets_megamenu = etsMM.ETS_MM_MENUS || null;
				if (typeof ets_megamenu.settings.mobile.open_submenu !== 'undefined' && ets_megamenu.settings.mobile.open_submenu) {
					var $this = $(this);
					var hasOpen = $this.parents('li.menu-item').hasClass('open');

					if (!hasOpen) {
						$this.parents('li.menu-item').addClass('open');
						$this.parents('li.menu-item:not(.is_menu_tabs)').parents('.ets_megamenu').addClass('open_sub_leve2');
					} else {
						$this.parents('li.menu-item').removeClass('open');
						$this.parents('.ets_megamenu').removeClass('open_sub_leve2');
					}
					if ($('#PageContainer').length && !$('.ets_megamenu').hasClass('ets_mm_embeddedcode')) {
						var menuHeight = $('.ets_megamenu.mm-mobile').height();
						$('#PageContainer').css('transform', 'translate3d(0px, ' + menuHeight + 'px, 0px)');
					}
				}

			});


			$(document).on('click touchend', '.js-ets-mm-btn-toggle-item_tab', function () {
				var hasOpenTab = $(this).parents('li.tab-item').hasClass('open');
				if (!hasOpenTab) {
					$(this).parents('li.tab-item').addClass('open');
					$(this).parents('li.menu-item.is_menu_tabs').parents('.ets_megamenu').addClass('open_sub_leve2');
				} else {
					$(this).parents('li.tab-item').removeClass('open');
					$(this).parents('.ets_megamenu').removeClass('open_sub_leve2');
				}
			});
			$(document).on('click', '.tab-menu-item-text', function () {
				var ets_megamenu = etsMM.ETS_MM_MENUS || null;
				if (typeof ets_megamenu.settings.mobile.open_submenu !== 'undefined' && ets_megamenu.settings.mobile.open_submenu) {
					var hasOpenTab = $(this).parents('li.tab-item').hasClass('open');
					if (!hasOpenTab) {
						$(this).parents('li.tab-item').addClass('open');
						$(this).parents('li.menu-item.is_menu_tabs').parents('.ets_megamenu').addClass('open_sub_leve2');
					} else {
						$(this).parents('li.tab-item').removeClass('open');
						$(this).parents('.ets_megamenu').removeClass('open_sub_leve2');
					}
				}

			});

			$(document).on('click', function (event) {
				setTimeout(function () {
					if (etsMM.isMobile() && $('.ets_megamenu:visible').length && !$('.ets_megamenu:visible').hasClass('mm-mobile') && !$('.ets_megamenu').hasClass('ets_mm_embeddedcode')) {
						$('.ets_megamenu:visible').addClass('mm-mobile');
						var menuHeight = $('.ets_megamenu.mm-mobile').height();
						if (!$('.ets_megamenu.mm-mobile').hasClass('ets-mega_menu'))
							$('#PageContainer').css('transform', 'translate3d(0px, ' + menuHeight + 'px, 0px)');
					}
				}, 100);
			});

			$(document).mouseup(function (e) {
				if (!$('.ets_mm_search').is(e.target) && $('.ets_mm_search').has(e.target).length === 0) {
					$('.ets_mm_search').removeClass('open');
				}
			});

			$(document).on('click', '.js-ets-mm-submit-search', function () {
				if (!$(this).closest('.ets_mm_search').hasClass('open')) {
					$(this).closest('.ets_mm_search').addClass('open');
					return false;
				}
				return true;
			});

			$(document).scroll(function () {
				var offsetTop = -1;
				var navItem = null;
				$('.ets_megamenu.sticky-menu:visible').each(function () {
					if ($(this).find('ul').is(':visible') && !etsMM.isMobile()) {
						navItem = $(this);
						return true;
					} else if (etsMM.isMobile() && $(this).hasClass('mm-mobile')) {
						navItem = $(this);
						return true;
					}
				});

				if (!navItem) {
					return true;
				}

				if ($('.ets_megamenu.sticky-menu:visible').length) {
					offsetTop = navItem.offset().top;
				}
				var scrollTop = $(window).scrollTop();
				var menuHeight = navItem.outerHeight();
				if (offsetTop >= 0 && scrollTop > 0 && scrollTop >= offsetTop && (!navItem.hasClass('mm-mobile') || (navItem.hasClass('mm-mobile') && navItem.hasClass('ets_mm_embeddedcode')))) {
					navItem.addClass('sticky_fixed');
					$('.ets_mm_height_sticky').css('height', menuHeight + 'px');
				} else {
					navItem.removeClass('sticky_fixed');
					$('.ets_mm_height_sticky').css('height', '0px');
				}
			});

			$(document).on('click', '.js-ets-mm-toggle-menu-mobile', function () {
				$(this).parents('.ets_megamenu').addClass('active_transition_css');
				$(this).addClass('open');
				if ($(this).hasClass('open')) {
					$(this).parent('.ets_megamenu').addClass('open');
				} else {
					$(this).parent('.ets_megamenu').removeClass('open');
				}
			});

			$(window).resize(function () {
				if (etsMM.isMobile()) {
					$('.ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').removeClass('ets-mm-hidden');
					$('.ets_mm_embeddedcode ').addClass('mm-mobile');
					if ($('.ets_megamenu.ets-mega_menu').length) {
						$('.ets_megamenu.ets-mega_menu').addClass('mm-mobile');
					}
				} else {
					$('.ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').addClass('ets-mm-hidden');
					$('.ets_mm_embeddedcode').removeClass('mm-mobile');
					if ($('.ets_megamenu.ets-mega_menu').length) {
						$('.ets_megamenu.ets-mega_menu').removeClass('mm-mobile');
					}
				}

				if (!etsMM.isMobile()) {
					$('li.menu-item.open').removeClass('open');
					$('li.tab-item.open').removeClass('open');
					$('body.open_sub_leve2').removeClass('open_sub_leve2');
					$('body').removeClass('active-overlay');
					if ($('.ets_megamenu.open_sub_leve2').length > 0) {
						$('.ets_megamenu').removeClass('open_sub_leve2');
					}
				}

			});

			$(document).on('click', '.js-ets-mm-close-mobile,.ets-item-header-mobile', function () {
				$('.js-ets-mm-toggle-menu-mobile').removeClass('open');
				$('.ets_megamenu ').removeClass('open');
				$(this).closest('.ets_megamenu').removeClass('js-menu--is-open');
				$('.js-mobile-nav-toggle').addClass('mobile-nav--open').removeClass('mobile-nav--close').attr('aria-expanded', 'false');
			});

			$(document).on('click', '.js-ets-mm-back-item', function () {
				$(this).closest('li.menu-item').removeClass('open');
				$(this).closest('li.tab-item').removeClass('open');
				$(this).closest('.ets_megamenu').removeClass('open_sub_leve2');
			});

			$(document).on('click', '.js-ets-mm-close-sub-menu', function () {
				$(this).closest('li.menu-item').removeClass('open');
				$(this).closest('li.tab-item').removeClass('open');
				$(this).closest('.ets_megamenu').removeClass('open_sub_leve2').removeClass('js-menu--is-open');
				$('.js-mobile-nav-toggle').addClass('mobile-nav--open').removeClass('mobile-nav--close').attr('aria-expanded', 'false');
			});

		});
	};

	if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7))
	{
		etsMmLoadJs('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function () {
			jQuery191 = jQuery.noConflict(true);
			try {
				etsMMJavascript(jQuery191);
			} catch (e) {
				console.log(e.message)
			}
		});
	}
	else
	{
		try {
			etsMMJavascript(jQuery);
		} catch (e) {
			console.log(e.message)
		}
	}

})();
